import React from 'react';

// Types
import { MetricSlugs } from './ManagerDashboardData.constants';

// Constants
import { ManagerDashboardLearnMoreData } from './ManagerDashboardData.constants';

// Components
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';
import { WpButton } from 'Wpds/components/button';

// Styles
import './ManagerDashboardLearnMoreModal.scss';

type Props = {
  slug: MetricSlugs;
  isOpen: boolean;
  toggleOpen: () => void;
};

const ManagerDashboardLearnMoreModal = ({ slug, isOpen, toggleOpen }: Props) => {
  if (!slug) return null;
  const data = ManagerDashboardLearnMoreData.find(item => item.slug === slug);
  const baseClassName = 'ManagerDashboardLearnMoreModal';

  return (
    <WpModal size="sm" isOpen={isOpen} onToggle={toggleOpen}>
      <WpModalHeader>{data.title}</WpModalHeader>
      <WpModalBody>
        {data.image && (
          <div className={`${baseClassName}__image`}>
            <img src={data.image} />
          </div>
        )}
        {data.description}
      </WpModalBody>
      <WpModalFooter>
        <WpButton variant="tertiary" onClick={toggleOpen}>
          Close
        </WpButton>
      </WpModalFooter>
    </WpModal>
  );
};

export default ManagerDashboardLearnMoreModal;
